var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V4C23 2.34315 21.6569 1 20 1H4ZM7.84282 19.277H4.5788V9.45699H7.84282V19.277ZM6.21081 8.11669H6.18924C5.09432 8.11669 4.38462 7.36235 4.38462 6.41949C4.38462 5.45594 5.11506 4.72298 6.23218 4.72298C7.34954 4.72298 8.03618 5.45594 8.05755 6.41949C8.05755 7.36235 7.34954 8.11669 6.21081 8.11669ZM19.6154 19.277H16.3505V14.0233C16.3505 12.7037 15.8788 11.803 14.6971 11.803C13.7947 11.803 13.2584 12.4094 13.0222 12.9969C12.9363 13.2068 12.9138 13.4985 12.9138 13.7927V19.2771H9.64832C9.64832 19.2771 9.69208 10.3783 9.64832 9.45704H12.9138V10.8486C13.3477 10.181 14.122 9.2265 15.8563 9.2265C18.0049 9.2265 19.6154 10.6297 19.6154 13.6457V19.277Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c0bcbc23285f3ff43a410b2bd20b41d0.svg";
export { ForwardRef as ReactComponent };